import React, { FC } from 'react';
import styled from 'styled-components';

import { TabType } from 'components/common/Tabs/V2Tabs';

import Bottom, { BottomProps, OrganizationAndRatingProps } from './Bottom/Bottom';
import PriceContainer, { LinkProps } from './PriceContainer/PriceContainer';
import Top from './Top/Top';
import InfoContainer from './InfoContainer';
import OptionsContainer from './OptionsContainer';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 2.25fr 0.75fr;
    grid-template-rows: auto auto;
    gap: 15px;

    @media (max-width: 490px) {
        grid-template-columns: 1fr;
        grid-template-rows: auto;
    }
`;

const LeftColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const RightColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-end;
`;

const BottomWrapper = styled.div`
  grid-column: 1 / -1;
`;

export type V2CardBodyProperties = {
    preTitle?: string;
    additionalPreTitleString?: string;
    activationStatusTextLabel?: string;
    activationStatus?: boolean;
    ratingScore?: number | null;
    scorePrecision?: number | null;
    showUserOptions?: boolean;
    title: string,
    lowestPriceLabel?: boolean;
    privateOfferLabel?: boolean;
    archivedLabel?: boolean;
    oldPrice?: string;
    link?: LinkProps;
    mainValue?: string;
    subMainValues?: (React.ReactNode | string)[];
    openOfferTab?: (tab: TabType) => void;
    organizationAndRating?: OrganizationAndRatingProps;
    calculationValue?: string;
    hasCalculationRole?: boolean;
    predictedPrice?: string;
    hasPredictionRole?: boolean;
    withPrediction?: boolean;
    offerPrice?: number;
    showLendiButtons?: boolean;
    isDuplicate?: boolean;
} & BottomProps;

const V2CardBodyDefault: FC<V2CardBodyProperties> = ({
    preTitle,
    additionalPreTitleString,
    activationStatusTextLabel,
    activationStatus,
    ratingScore,
    scorePrecision,
    showUserOptions,
    userDetails,
    title,
    infoElements,
    lowestPriceLabel,
    privateOfferLabel,
    archivedLabel,
    oldPrice,
    link,
    modifications,
    notInteractiveElements,
    isNotInteractive,
    interactiveElements,
    mainValue,
    subMainValues,
    showMessages,
    setShowMessages,
    openOfferTab,
    organizationAndRating,
    calculationValue,
    predictedPrice,
    withPrediction,
    hasCalculationRole,
    hasPredictionRole,
    offerPrice,
    showLendiButtons,
    isDuplicate
}) => {
    return (
        <Wrapper>
            <LeftColumn>
                <Top
                    preTitle={preTitle}
                    additionalPreTitleString={additionalPreTitleString}
                    withPrediction={withPrediction}
                    title={title}
                    activationStatusTextLabel={activationStatusTextLabel}
                    activationStatus={activationStatus}
                    ratingScore={ratingScore}
                    scorePrecision={scorePrecision}
                    lowestPriceLabel={lowestPriceLabel}
                    privateOfferLabel={privateOfferLabel}
                    archivedLabel={archivedLabel}
                    hasPredictionRole={hasPredictionRole}
                    isDuplicate={isDuplicate}
                />
                <InfoContainer
                    title={title}
                    infoElements={infoElements}
                    ratingScore={ratingScore}
                    scorePrecision={scorePrecision}
                    isUpperLabel={lowestPriceLabel || privateOfferLabel || archivedLabel}
                    openOfferTab={openOfferTab}
                    modifications={modifications}
                />
            </LeftColumn>
            <RightColumn>
                <OptionsContainer showUserOptions={showUserOptions} userDetails={userDetails}/>
                <PriceContainer
                    isUpperLabel={lowestPriceLabel || privateOfferLabel || archivedLabel}
                    oldPrice={oldPrice}
                    mainValue={mainValue}
                    subMainValues={subMainValues}
                    calculationValue={calculationValue}
                    hasCalculationRole={hasCalculationRole}
                    predictedPrice={predictedPrice}
                    hasPredictionRole={hasPredictionRole}
                    link={link}
                    modifications={modifications}
                    openOfferTab={openOfferTab}
                    organizationAndRating={organizationAndRating}
                    ratingScore={ratingScore}
                    scorePrecision={scorePrecision}
                    showLendiButton={showLendiButtons}
                    offerPrice={offerPrice}
                />
            </RightColumn>
            <BottomWrapper>
                <Bottom
                    infoElements={infoElements}
                    modifications={modifications}
                    userDetails={userDetails}
                    calculationValue={calculationValue}
                    notInteractiveElements={notInteractiveElements}
                    isNotInteractive={isNotInteractive}
                    interactiveElements={interactiveElements}
                    showMessages={showMessages}
                    setShowMessages={setShowMessages}
                    openOfferTab={openOfferTab}
                    organizationAndRating={organizationAndRating}
                    predictedPrice={predictedPrice}
                    hasCalculationRole={hasCalculationRole}
                    hasPredictionRole={hasPredictionRole}
                /></BottomWrapper>
        </Wrapper>
    );
};

export default V2CardBodyDefault;
